


function AdultIndicator() {

    return (
        <div className="adult-indicator-container">
            18+
        </div>
    )
}

export default AdultIndicator;